<template>
    <span>
        <svg
            v-if="name === 'edit'"
            width="12"
            height="12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0)">
                <path
                    d="M7.462 2.022l2.441 2.441-6.18 6.18L1.285 8.2l6.178-6.179zm4.293-.589L10.667.345a1.08 1.08 0 00-1.526 0L8.098 1.388l2.44 2.44 1.217-1.216a.832.832 0 000-1.179zM.007 11.633c-.045.2.136.378.336.33l2.72-.66-2.44-2.44-.616 2.77z"
                    fill="#fff"
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0h12v12H0z" />
                </clipPath>
            </defs>
        </svg>
        <svg
            v-if="name === 'delete'"
            width="12"
            height="12"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path
                d="M505.943 6.058c-8.077-8.077-21.172-8.077-29.249 0L6.058 476.693c-8.077 8.077-8.077 21.172 0 29.249A20.612 20.612 0 0020.683 512a20.614 20.614 0 0014.625-6.059L505.943 35.306c8.076-8.076 8.076-21.171 0-29.248z"
                fill="#fff"
            />
            <path
                d="M505.942 476.694L35.306 6.059c-8.076-8.077-21.172-8.077-29.248 0-8.077 8.076-8.077 21.171 0 29.248l470.636 470.636a20.616 20.616 0 0014.625 6.058 20.615 20.615 0 0014.624-6.057c8.075-8.078 8.075-21.173-.001-29.25z"
                fill="#fff"
            />
        </svg>
        <svg
            v-if="name === 'upload'"
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.8039 4.15231C10.6728 2.16523 9.01436 0.588585 6.99467 0.588585C4.97446 0.588585 3.31576 2.16589 3.18536 4.1537C1.37917 4.38091 0 5.91966 0 7.76602C0 9.7761 1.63532 11.4115 3.64545 11.4115H9.18931C9.34699 11.4115 9.47488 11.2836 9.47488 11.1259C9.47488 10.9682 9.34699 10.8403 9.18931 10.8403H3.64545C1.95025 10.8403 0.571126 9.46117 0.571126 7.76602C0.571126 6.13474 1.84821 4.78817 3.47849 4.70045C3.63003 4.69231 3.74872 4.56705 3.74872 4.41532C3.74872 4.40965 3.74858 4.40409 3.74825 4.39842C3.75253 2.61194 5.20719 1.15971 6.99467 1.15971C8.78243 1.15971 10.2373 2.61218 10.2411 4.39909C10.2409 4.40461 10.2407 4.41042 10.2407 4.41475C10.2407 4.56686 10.3599 4.69227 10.5118 4.69993C12.1476 4.78279 13.4289 6.12955 13.4289 7.76597C13.4289 8.69529 13.0149 9.56506 12.2931 10.1522C12.1707 10.2517 12.1523 10.4316 12.2518 10.5539C12.3513 10.6763 12.5312 10.6948 12.6535 10.5952C13.5092 9.89913 14 8.86791 14 7.76592C14 5.91391 12.6162 4.37458 10.8039 4.15231Z"
                fill="white"
            />
            <path
                d="M6.70911 5.71443V9.35588C6.70911 9.51356 6.83699 9.64144 6.99467 9.64144C7.15235 9.64144 7.28023 9.51356 7.28023 9.35588V5.71443C7.28023 5.55676 7.15235 5.42887 6.99467 5.42887C6.83699 5.42887 6.70911 5.55676 6.70911 5.71443Z"
                fill="white"
            />
            <path
                d="M8.62795 6.24396C8.70106 6.24396 8.77411 6.21608 8.82989 6.16034C8.9414 6.04883 8.9414 5.86802 8.82989 5.75651L7.19661 4.12323C7.0851 4.01172 6.90424 4.01172 6.79278 4.12323L5.1595 5.75651C5.04799 5.86802 5.04799 6.04883 5.1595 6.16034C5.27101 6.27186 5.45187 6.27186 5.56333 6.16034L6.99467 4.72901L8.42601 6.16034C8.48179 6.21608 8.55489 6.24396 8.62795 6.24396Z"
                fill="white"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'PhotoInputIcon',
    props: {
        name: {
            type: String,
            default: '',
        },
    },
};
</script>
